import { HttpClient } from '../../httpClient'
import { OpalApiRequestParams } from '../../schema'

interface DeleteMomentScheduleArguments {
  params: OpalApiRequestParams<'DeleteMomentScheduleV3'>
}
export function deleteMomentSchedule({
  params,
}: DeleteMomentScheduleArguments): Promise<void> {
  const url = new URL(
    `/moment_schedules/v3/${params.path.moment_schedule_id}`,
    window.location.origin
  )

  return HttpClient()
    .delete(url.toString())
    .then((res) => res.data)
}
